import { createValidIcon } from '@ui/icons/utils/type-helper'

export const InfoFilledIcon = createValidIcon((props) => {
  const { size, color, secondaryColor = 'text-white' } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <circle cx='12' cy='12' r='10' fill={color} />
      <path
        d='M11 15.5498C11 16.1021 11.4477 16.5498 12 16.5498C12.5523 16.5498 13 16.1021 13 15.5498V11.5498C13 10.9975 12.5523 10.5498 12 10.5498C11.4477 10.5498 11 10.9975 11 11.5498V15.5498Z'
        fill={secondaryColor}
      />
      <path
        d='M12.0498 9.5498C12.6021 9.5498 13.0498 9.10208 13.0498 8.5498V8.45019C13.0498 7.89944 12.6045 7.45236 12.0537 7.4502L11.9541 7.44981C11.6882 7.44876 11.4329 7.55366 11.2445 7.74131C11.0561 7.92895 10.9502 8.1839 10.9502 8.4498V8.5498C10.9502 9.10208 11.3979 9.5498 11.9502 9.5498H12.0498Z'
        fill={secondaryColor}
      />
    </svg>
  )
})
